import { isStoredAccessTokenExpired, refreshAccessToken } from "@istari-frontend/auth";

/** Renews the access token when storage says it has already expired. */
export async function refreshExpiredAccessToken(): Promise<void> {
  if (isStoredAccessTokenExpired()) {
    await refreshAccessToken();
  }
}

/**
 * Applies `prop` to a client constructed at call time, so the request carries the
 * token currently in storage rather than the one captured when the proxy was built.
 */
export async function invokeWithCurrentToken<TClient extends object>(
  createClient: () => TClient,
  prop: keyof TClient,
  args: unknown[],
): Promise<unknown> {
  const client = createClient();
  const method = client[prop] as (...methodArgs: unknown[]) => unknown;
  return await method.apply(client, args);
}
